import { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom"; 

export const NavButton = ({ label, variant = "default" }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const timeoutRef = useRef(null);
  const navigate = useNavigate(); 

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleMouseEnter = () => {
    clearTimeout(timeoutRef.current);
    if (variant === "outlined" && label === "Sign Up") {
      setIsDropdownOpen(true);
    }
  };

  const handleMouseLeave = () => {
    timeoutRef.current = setTimeout(() => {
      if (!isDropdownOpen) return;
      setIsDropdownOpen(false);
    }, 200);
  };

  const handleNavigation = (option) => {
    setIsDropdownOpen(false);
    switch (option) {
      case "Sign Up as Student":
        navigate("/auth/signup/student");
        break;
      case "Sign Up as Tutor":
        navigate("/auth/signup/trainer");
        break;
      case "Sign Up as Company":
        navigate("/auth/signup/company");
        break;
      default:
        break;
    }
  };

  const handleLoginClick = () => {
    if (label === "Login") {
      navigate("/auth/login");
    }
  };

  const baseClasses =
    "flex justify-center items-center p-3 my-auto cursor-pointer text-base max-md:text-sm max-md:p-1.5 transition-all duration-200";

  const variantClasses =
    variant === "outlined"
      ? "rounded-lg border-2 border-solid border-slate-900 hover:bg-gray-700 hover:text-white hover:shadow-lg max-md:border-[1px]"
      : "cursor-pointer hover:bg-gray-100 rounded-lg";

  const dropdownOptions = [
    "Sign Up as Student",
    "Sign Up as Tutor",
    "Sign Up as Company",
  ];

  return (
    <div 
      className="relative" 
      ref={dropdownRef}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <button
        className={`${baseClasses} ${variantClasses}`}
        aria-label={label}
        aria-expanded={isDropdownOpen}
        onClick={(event) => {
          event.stopPropagation();
          if (variant === "outlined" && label === "Sign Up") {
            setIsDropdownOpen(!isDropdownOpen);
            clearTimeout(timeoutRef.current);
          } else if (label === "Login") {
            handleLoginClick();
          }
        }}
      >
        <span className="self-stretch px-4 my-auto max-md:px-2 whitespace-nowrap">
          {label}
        </span>
      </button>

      {variant === "outlined" &&
        label === "Sign Up" &&
        isDropdownOpen && (
          <div 
            className="absolute top-full left-0 max-md:right-0 max-md:left-auto mt-2 w-48 bg-white border border-gray-200 rounded-lg shadow-lg z-50 transform transition-all duration-200 ease-in-out"
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          >
            {dropdownOptions.map((option) => (
              <button
                key={option}
                className="w-full px-4 py-2 text-left hover:bg-gray-100 text-sm transition-colors rounded-lg m-1 hover:shadow-md hover:scale-105 transform transition-all duration-200 ease-in-out"
                onClick={() => handleNavigation(option)}
              >
                {option}
              </button>
            ))}
          </div>
        )}
    </div>
  );
};
